import * as React from "react";
import "./style.scss";

export default function Card ({children,icon,className}){
    return (
        <div className={`card ${className}`}>
            {icon}
            <p>
                {children}
            </p>
        </div>
    )
}